/*
 * Constants
 */

const scope = 'parousya-saas-web/AppsMenu';

export const REDUX_ROOT = 'appsMenu';

export const LOAD_DATA = `${scope}/LOAD_DATA`;
export const LOAD_DATA_SUCCESS = `${scope}/LOAD_DATA_SUCCESS`;
export const LOAD_DATA_ERROR = `${scope}/LOAD_DATA_ERROR`;
